import {
  DEV_TG_WRAPPER_LINK,
  PROD_EXCLUSIVE_TG_BOT_LINK,
  PROD_LITE_TG_WRAPPER_LINK,
  PROD_TG_WRAPPER_LINK,
} from '@/shared/constants';
import { useAppStateRaw } from '@/shared/stores/app-store/app-store';

import { base64Utils } from '../../base64-utils';
import { getIsDev } from '../../environment/get-is-dev';
export const getShareLink = (
  gameKey: string,
  params?: Record<string, any> | string
): string => {
  const { isLiteMode, isExclusiveMode } = useAppStateRaw.getState();
  //if the parameter has no name, then it gets the name "default"
  const resolvedParams = typeof params !== 'object' ? { default: params } : params;

  const startappParams = {
    game: {
      key: gameKey,
      ...(resolvedParams && { raw: resolvedParams }),
    },
  };

  const encodedStartapp = base64Utils.encode(startappParams);

  const isDev = getIsDev();

  function getWrapperLink({
    isDev,
    isLite,
    isExclusive,
  }: {
    isDev: boolean;
    isLite: boolean;
    isExclusive: boolean;
  }) {
    if (isExclusive) return PROD_EXCLUSIVE_TG_BOT_LINK;
    if (isLite) return PROD_LITE_TG_WRAPPER_LINK;
    return isDev ? DEV_TG_WRAPPER_LINK : PROD_TG_WRAPPER_LINK;
  }

  const wrapperLink = getWrapperLink({
    isDev,
    isLite: isLiteMode,
    isExclusive: isExclusiveMode,
  });

  const shareLink = `${wrapperLink}?startapp=${encodedStartapp}`;

  return shareLink;
};
